import React from "react";

import { APP_COMMIT_SHA, APP_VERSION } from "../generated/appVersion";

type AppVersionTextProps = {
  className?: string;
};

export function AppVersionText({ className }: AppVersionTextProps) {
  const version = process.env.REACT_APP_VERSION || APP_VERSION;
  const commitSha = process.env.REACT_APP_COMMIT_SHA || APP_COMMIT_SHA;
  return <p className={className}>v{version}{commitSha ? `+${commitSha}` : ""}</p>;
}
